import React from 'react';
import {ContainerBoxWrong, SubTitleWrong, TitleWrong} from '../Style/ManualRefinement.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';


const WrongRequest = () => (
    <ContainerBoxWrong>
        <TitleWrong>{_SYSTEM_TITLES.somethingWentWrong}</TitleWrong>
        <SubTitleWrong>{_SYSTEM_TITLES.somethingWentWrongSubTitle}</SubTitleWrong>
    </ContainerBoxWrong>
);

export default WrongRequest;
